import { initAlpineDataTable } from './datatable-filters';
import InputMask from './input-mask';
import Alpine from 'alpinejs';

window.displayFeedback = function (message, showAsError = false) {
  const feedbackWrap = document.querySelector('.feedback-wrap');
  if (showAsError) {
    feedbackWrap.classList.add('error');
  }
  const feedback = document.querySelector('.feedback p');

  feedback.textContent = message;
  feedbackWrap.style.display = 'block';

  setTimeout(function () {
    feedbackWrap.style.display = 'none';
    feedback.textContent = '';
    if (showAsError) {
      feedbackWrap.classList.remove('error');
    }
  }, 5000);
};

window.displayError = function (message) {
  displayFeedback(message, true);
};

window.reloadThenDisplayFeedback = function (message) {
  localStorage.setItem('displayFeedback', message);
  window.location.reload();
}

window.setDisplayEachEl = function (root, selector, display) {
  root.querySelectorAll(selector).forEach(el => el.style.display = display);
};

InputMask.applyToAll();

window.Alpine = Alpine;

document.querySelectorAll(".jqdtbl-filters").forEach((el) => {
  initAlpineDataTable(Alpine, {
    storeName: el.getAttribute("data-store"),
    tableSelector: '#'+el.getAttribute("data-table-id"),
    requestedApiUrl: el.getAttribute("data-api-url"),
  });
});

Alpine.start();

document.addEventListener('DOMContentLoaded', (event) => {
  const message = localStorage.getItem('displayFeedback');
  if (message !== null) {
    displayFeedback(message);
    localStorage.removeItem('displayFeedback');
  }
});
